import { Language } from '../types';
import { getPathForView } from './routes';
import { getCityBySlug } from '../data/citiesData';
import { getRegionalZoneBySlug } from '../data/regionalZonesData';

interface SeoData {
  title: Record<Language, string>;
  description: Record<Language, string>;
}

const SEO_MAPPINGS: Record<string, SeoData> = {
  home: {
    title: {
      fr: 'API HEAT - Plomberie, Chauffage & Débouchage Urgent 24/7 en Belgique',
      nl: 'API HEAT - Loodgieter, Verwarming & Dringende Ontstopping 24/7 in België',
      en: 'API HEAT - Emergency Plumber, Heating & Drain Unblocking 24/7 Belgium'
    },
    description: {
      fr: 'Experts en plomberie, chauffage et débouchage express 24/7 à Bruxelles, en Wallonie et en Flandre. Techniciens agréés, devis gratuit et intervention en 30 min.',
      nl: 'Experten in loodgieterij, verwarming en dringende ontstopping 24/7 in Brussel, Wallonië en Vlaanderen. Gecertificeerde technici, gratis offerte en interventie in 30 min.',
      en: 'Experts in plumbing, heating, and emergency drain unblocking 24/7 across Brussels, Wallonia, and Flanders. Certified technicians, free quote and 30 min response.'
    }
  },
  services: {
    title: {
      fr: 'Nos Services - Plomberie, Chauffage & Débouchage | API HEAT Belgique',
      nl: 'Onze Diensten - Loodgieterij, Verwarming & Ontstopping | API HEAT België',
      en: 'Our Services - Plumbing, Heating & Unblocking | API HEAT Belgium'
    },
    description: {
      fr: 'Découvrez nos prestations professionnelles en plomberie, entretien de chaudière gaz, et débouchage haute pression en Belgique.',
      nl: 'Ontdek onze professionele diensten in loodgieterij, onderhoud van gasketel en hogedruk ontstopping in België.',
      en: 'Explore our professional services in plumbing, gas boiler maintenance, and high-pressure drain unblocking across Belgium.'
    }
  },
  zones: {
    title: {
      fr: 'Zones d\'Intervention 24/7 - Bruxelles, Flandre, Wallonie | API HEAT',
      nl: 'Interventiegebieden 24/7 - Brussel, Vlaanderen, Wallonië | API HEAT',
      en: 'Service Areas 24/7 - Brussels, Flanders, Wallonia | API HEAT Belgium'
    },
    description: {
      fr: 'Intervention rapide en 30 minutes dans toutes les communes de Bruxelles, Anvers, Liège, Gand, Charleroi et partout en Belgique.',
      nl: 'Snelle interventie binnen 30 minuten in alle gemeenten van Brussel, Antwerpen, Luik, Gent, Charleroi en heel België.',
      en: 'Rapid response within 30 minutes across all municipalities in Brussels, Antwerp, Liège, Ghent, Charleroi, and throughout Belgium.'
    }
  },
  about: {
    title: {
      fr: 'À Propos & Nos Engagements - API HEAT Belgique',
      nl: 'Over Ons & Onze Diensten - API HEAT België',
      en: 'About Us & Our Commitments - API HEAT Belgium'
    },
    description: {
      fr: 'Leader belge des services d\'urgence technique et de rénovation énergétique. Agréé dans toute la Belgique.',
      nl: 'Belgische marktleider in technische nooddiensten en energierenovatie. Erkend in heel België.',
      en: 'Belgium’s leading technical emergency and energy renovation provider. Certified across Belgium.'
    }
  },
  contact: {
    title: {
      fr: 'Contact & Devis Gratuit 24/7 - API HEAT Belgique',
      nl: 'Contact & Gratis Offerte 24/7 - API HEAT België',
      en: 'Contact & Free Quote 24/7 - API HEAT Belgium'
    },
    description: {
      fr: 'Contactez notre centrale d\'urgence 24/7 ou demandez un devis gratuit en ligne pour vos travaux de plomberie et chauffage en Belgique.',
      nl: 'Neem contact op met onze nooddienst 24/7 of vraag online een gratis offerte aan voor uw loodgieterij en verwarming in België.',
      en: 'Contact our 24/7 emergency dispatch or request a free online quote for your plumbing and heating projects in Belgium.'
    }
  },
  'service-plumbing': {
    title: {
      fr: 'Plomberie & Sanitaire 24/7 - Dépannage Urgence | API HEAT Belgique',
      nl: 'Loodgieterij & Sanitair 24/7 - Dringende Herstelling | API HEAT België',
      en: 'Plumbing & Sanitary 24/7 - Emergency Repair | API HEAT Belgium'
    },
    description: {
      fr: 'Dépannage plomberie express en 30 min, recherche de fuite non destructive et rénovation de salle de bain en Belgique. Techniciens agréés.',
      nl: 'Dringende loodgieterdienst binnen 30 min, lekdetectie en badkamerrenovatie in België. Gecertificeerde technici.',
      en: 'Express plumbing repairs within 30 mins, non-destructive leak detection, and bathroom renovation in Belgium. Certified technicians.'
    }
  },
  'service-heating': {
    title: {
      fr: 'Chauffagiste & Entretien Chaudière 24/7 | API HEAT Belgique',
      nl: 'Verwarming & Onderhoud Gasketel 24/7 | API HEAT België',
      en: 'Heating Engineer & Boiler Service 24/7 | API HEAT Belgium'
    },
    description: {
      fr: 'Entretien légal chaudière gaz, dépannage chauffage central 7j/7 par des chauffagistes agréés en Belgique.',
      nl: 'Wettelijk onderhoud gasketel, centrale verwarming herstelling 7j/7 door erkende technici in België.',
      en: 'Legal gas boiler maintenance, central heating repairs 7/7 by certified heating engineers in Belgium.'
    }
  },
  'service-unblocking': {
    title: {
      fr: 'Débouchage Urgent 24/7 & Hydrocurage | API HEAT Belgique',
      nl: 'Dringende Ontstopping 24/7 & Hogedruk | API HEAT Belgium',
      en: 'Emergency Drain Unblocking 24/7 & Hydro-jetting | API HEAT Belgium'
    },
    description: {
      fr: 'Débouchage canalisation, WC, évier, inspection caméra haute définition et hydrocurage d\'égouts 24/7 partout en Belgique.',
      nl: 'Ontstopping van riolering, toilet, gootsteen, HD camera-inspectie en ruiming 24/7 in heel België.',
      en: 'Drain unblocking for toilets, sinks, sewers, HD camera inspection and hydro-jetting 24/7 across Belgium.'
    }
  },
  'service-ventilation': {
    title: {
      fr: 'Ventilation VMC Simple & Double Flux 24/7 | API HEAT Belgique',
      nl: 'Ventilatie VMC Enkel & Dubbele Stroom 24/7 | API HEAT België',
      en: 'Ventilation & Heat Recovery VMC 24/7 | API HEAT Belgium'
    },
    description: {
      fr: 'Installation, dépannage et entretien de systèmes de ventilation mécanique contrôlée (VMC) résidentiels et tertiaires en Belgique.',
      nl: 'Installatie, onderhoud en herstelling van mechanische ventilatiesystemen (VMC) in België.',
      en: 'Installation, repair, and maintenance of mechanical ventilation heat recovery systems in Belgium.'
    }
  },
  'service-water-softener': {
    title: {
      fr: 'Adoucisseur d\'Eau & Anti-Calcaire 24/7 | API HEAT Belgique',
      nl: 'Waterontharder & Ontkalker 24/7 | API HEAT België',
      en: 'Water Softener Installation & Repair 24/7 | API HEAT Belgium'
    },
    description: {
      fr: 'Installation, entretien et dépannage d\'adoucisseurs d\'eau toutes marques contre le tartre et le calcaire en Belgique.',
      nl: 'Installatie, onderhoud en herstelling van waterontharders tegen kalk in België.',
      en: 'Installation, maintenance, and repair of water softeners against limescale across Belgium.'
    }
  },
  admin: {
    title: {
      fr: 'Administration & Configuration - API HEAT',
      nl: 'Beheer & Configuratie - API HEAT',
      en: 'Admin & Settings - API HEAT'
    },
    description: {
      fr: 'Panneau de configuration et administration API HEAT.',
      nl: 'Beheerderspaneel en instellingen API HEAT.',
      en: 'API HEAT management and settings panel.'
    }
  }
};

export function updatePageSeo(view: string, lang: Language) {
  let title = '';
  let description = '';

  if (view.startsWith('zone-')) {
    const slug = view.replace('zone-', '');
    const city = getCityBySlug(slug);
    if (city) {
      if (lang === 'nl') {
        title = `Loodgieter, Verwarming & Ontstopping 24/7 in ${city.name} | API HEAT`;
      } else if (lang === 'en') {
        title = `Emergency Plumber, Heating & Drain Unblocking in ${city.name} | API HEAT`;
      } else {
        title = `Plombier, Chauffagiste & Débouchage 24/7 à ${city.name} | API HEAT`;
      }
      description = city.description[lang] || city.description['fr'];
    } else {
      const regionalZone = getRegionalZoneBySlug(slug);
      if (regionalZone) {
        if (lang === 'nl') {
          title = `Loodgieter, CV & Ontstopping 24/7 - ${regionalZone.name.nl} | API HEAT`;
        } else if (lang === 'en') {
          title = `Emergency Plumber, Heating & Drains 24/7 - ${regionalZone.name.en} | API HEAT`;
        } else {
          title = `Plombier Chauffagiste & Débouchage 24/7 - ${regionalZone.name.fr} | API HEAT`;
        }
        description = regionalZone.leadText[lang] || regionalZone.leadText.fr;
      }
    }
  }

  if (!title) {
    const seo = SEO_MAPPINGS[view] || SEO_MAPPINGS['home'];
    title = seo.title[lang] || seo.title['fr'];
    description = seo.description[lang] || seo.description['fr'];
  }

  document.title = title;

  // Helper to set or create meta tag
  const setMetaTag = (attributeName: string, attributeValue: string, content: string) => {
    let el = document.querySelector(`meta[${attributeName}="${attributeValue}"]`);
    if (!el) {
      el = document.createElement('meta');
      el.setAttribute(attributeName, attributeValue);
      document.head.appendChild(el);
    }
    el.setAttribute('content', content);
  };

  // Standard Meta Description
  setMetaTag('name', 'description', description);

  // Clean Canonical URL
  const cleanPath = getPathForView(view, lang === 'fr' ? undefined : lang);
  const canonicalUrl = `https://apiheat.be${cleanPath}`;

  // OpenGraph Tags
  setMetaTag('property', 'og:title', title);
  setMetaTag('property', 'og:description', description);
  setMetaTag('property', 'og:url', canonicalUrl);
  setMetaTag('property', 'og:locale', lang === 'nl' ? 'nl_BE' : lang === 'en' ? 'en_US' : 'fr_BE');

  // Twitter Tags
  setMetaTag('name', 'twitter:title', title);
  setMetaTag('name', 'twitter:description', description);
  setMetaTag('name', 'twitter:url', canonicalUrl);

  // Canonical link tag
  let canonicalLink = document.querySelector('link[rel="canonical"]');
  if (!canonicalLink) {
    canonicalLink = document.createElement('link');
    canonicalLink.setAttribute('rel', 'canonical');
    document.head.appendChild(canonicalLink);
  }
  canonicalLink.setAttribute('href', canonicalUrl);

  // Update html lang attribute
  document.documentElement.setAttribute('lang', lang === 'nl' ? 'nl-BE' : lang === 'en' ? 'en-BE' : 'fr-BE');
}
